import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { hot } from 'react-hot-loader';
import styled from 'styled-components';
import {
    columnSize,
    columnOffset,
    Column,
    Row,
} from '@zocdoc-frontend-common/styles-grid';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { DoctorCard } from '../../components/DoctorCard';
import { formatAppointmentTimeForDisplay } from '../../utils';
import { completeLUXPageTransition } from '../../utils/LUXUtils';
import SignInPageControlView from './SignInPageControlView';
import { START_SIGN_IN_STRINGS } from './constants';

class SignInPageView extends Component {
    static propTypes = {
        appointmentTime: PropTypes.string,
        facebookLoginUrl: PropTypes.string,
        forgotPasswordLinkTarget: PropTypes.string,
        googleLoginUrl: PropTypes.string,
        appleLoginUrl: PropTypes.string,
        locationId: PropTypes.string,
        locationTimeZoneId: PropTypes.string.isRequired,
        onClickCreateAccount: PropTypes.func,
        onSignInSuccess: PropTypes.func,
        procedureId: PropTypes.string,
        providerId: PropTypes.string,
        returnUrl: PropTypes.string,
        showFacebookLoginButton: PropTypes.bool,
        showGoogleLoginButton: PropTypes.bool,
        showAppleLoginButton: PropTypes.bool,
        showRememberMe: PropTypes.bool,
        signedIn: PropTypes.bool,
        trackMadeItToSignIn: PropTypes.func,
    };

    static defaultProps = {
        onClickCreateAccount: noop,
        onSignInSuccess: noop,
        returnUrl: '',
        trackMadeItToSignIn: noop,
    };

    componentDidMount() {
        const {
            isPatient,
            location,
            triggerNotAPatient,
            dispatchPageLoadTime,
        } = this.props;

        dispatchPageLoadTime('Sign In');
        completeLUXPageTransition('Booking - Sign In', location);

        if (!isPatient && triggerNotAPatient) {
            triggerNotAPatient();
        }

        this.props.trackMadeItToSignIn();
    }

    componentDidUpdate(prevProps) {
        const { responseBody, signedIn, onSignInSuccess } = this.props;

        if (responseBody && signedIn && prevProps.signedIn !== signedIn) {
            onSignInSuccess(responseBody);
        }
    }

    render() {
        const {
            appointmentTime,
            facebookLoginUrl,
            forgotPasswordLinkTarget,
            googleLoginUrl,
            appleLoginUrl,
            locationId,
            locationTimeZoneId,
            onClickCreateAccount,
            procedureId,
            providerId,
            returnUrl,
            showFacebookLoginButton,
            showGoogleLoginButton,
            showAppleLoginButton,
            showRememberMe,
            signInEndpoint,
        } = this.props;

        return (
            <DocumentTitle title={START_SIGN_IN_STRINGS.SignInDocumentTitle}>
                <div>
                    <Spacer />
                    <Row>
                        <DoctorCardWrapper>
                            <DoctorCard
                                formattedAppointmentTime={formatAppointmentTimeForDisplay(
                                    appointmentTime,
                                    locationTimeZoneId
                                )}
                                locationId={locationId}
                                procedureId={procedureId}
                                providerId={providerId}
                                showOnlyLocationForMobile
                            />
                        </DoctorCardWrapper>

                        <SignInFormWrapper>
                            <SignInPageControlView
                                facebookLoginUrl={facebookLoginUrl}
                                forgotPasswordLinkTarget={
                                    forgotPasswordLinkTarget
                                }
                                googleLoginUrl={googleLoginUrl}
                                appleLoginUrl={appleLoginUrl}
                                onClickCreateAccount={onClickCreateAccount}
                                pageTitle={
                                    START_SIGN_IN_STRINGS.SignInPageTitle
                                }
                                returnUrl={returnUrl}
                                showFacebookLoginButton={
                                    showFacebookLoginButton
                                }
                                showGoogleLoginButton={showGoogleLoginButton}
                                showAppleLoginButton={showAppleLoginButton}
                                showRememberMe={showRememberMe}
                                signInEndpoint={signInEndpoint}
                            />
                        </SignInFormWrapper>
                    </Row>
                </div>
            </DocumentTitle>
        );
    }
}

const Spacer = styled(Row)`
    ${breakpoint.small} {
        margin-top: 50px;
    }
`;

const SignInFormWrapper = styled.div`
    width: 100%;
    float: right;

    ${breakpoint.small} {
        float: none;
    }
`;

const oneColumnPct = `${(1 / 24) * 100}%`;

const DoctorCardWrapper = styled(Column).attrs({ end: true })`
    margin-bottom: 20px;

    ${breakpoint.small} {
        ${columnSize(7)};
        ${columnOffset(3)};
        margin: 0;
        margin-right: ${oneColumnPct};
        float: right;
    }
`;

export default hot(module)(SignInPageView);
